import { SignInButton, SignedIn, SignedOut, UserButton } from "@clerk/clerk-react";
import { Link } from "@tanstack/react-router";
import { TopBar } from "@/layouts/TopBar";
import { siteOrigin } from "@/lib/siteOrigin";
import styles from "./ProductTopBar.module.scss";

/** Browsing is public; account creation is deferred until a design is chosen. */
export function ProductTopBar() {
  return (
    <TopBar>
      <Link className={styles.brand} to="/">
        <span className={styles.mark}>A</span>
        <span>ARCHI</span>
      </Link>
      <nav className={styles.nav} aria-label="Product">
        <Link to="/designs">Designs</Link>
        <a href="/#how-it-works">How it works</a>
        <Link to="/editor">My invitations</Link>
      </nav>
      <SignedOut>
        <SignInButton mode="modal" forceRedirectUrl={`${siteOrigin()}/editor`}>
          <button type="button" className={styles.signIn}>
            Sign in
          </button>
        </SignInButton>
      </SignedOut>
      <SignedIn>
        <Link className={styles.mobileInvitations} to="/editor">My invitations</Link>
        <UserButton afterSignOutUrl="/" />
      </SignedIn>
      <Link className={styles.create} to="/designs">
        Create invitation <span aria-hidden="true">↗</span>
      </Link>
    </TopBar>
  );
}
